"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _peractoConfig = require("@peracto/peracto-config");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faBoxFull = require("@fortawesome/pro-regular-svg-icons/faBoxFull");

var _core = require("@chakra-ui/core");

var _lite = _interopRequireDefault(require("algoliasearch/lite"));

var _reactInstantsearchDom = require("react-instantsearch-dom");

var _isObjectLike = _interopRequireDefault(require("lodash/isObjectLike"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _sortBy = _interopRequireDefault(require("lodash/sortBy"));

var _excluded = ["product", "isEditMode", "productCardDirection", "hitsDirection", "fontColour", "fontFamily", "attributes", "attributeOperator", "isFirst", "isLast", "index", "fallbackImage"],
    _excluded2 = ["state"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
} // Attributes that don't start with 'attributes.*'


var UNPREFIXED_ATTRIBUTES = ['sku'];

var Icon = function Icon() {
  return /*#__PURE__*/_react["default"].createElement(_core.Flex, {
    py: 10,
    justifyContent: "center",
    alignItems: "center",
    w: "100%"
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faBoxFull.faBoxFull,
    size: "6x"
  }));
};

var ProductCard = function ProductCard(_ref) {
  var _product$resources;

  var product = _ref.product,
      isEditMode = _ref.isEditMode,
      _ref$productCardDirec = _ref.productCardDirection,
      productCardDirection = _ref$productCardDirec === void 0 ? 'column' : _ref$productCardDirec,
      hitsDirection = _ref.hitsDirection,
      fontColour = _ref.fontColour,
      fontFamily = _ref.fontFamily,
      attributes = _ref.attributes,
      attributeOperator = _ref.attributeOperator,
      isFirst = _ref.isFirst,
      isLast = _ref.isLast,
      index = _ref.index,
      fallbackImage = _ref.fallbackImage,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var images = (_product$resources = product.resources) === null || _product$resources === void 0 ? void 0 : _product$resources.filter(function (r) {
    return r.type === 'image';
  });
  var firstImage = images ? (0, _sortBy["default"])(images, ['displayOrder'])[0] : null;
  return /*#__PURE__*/_react["default"].createElement(_core.Stack, _extends({
    className: "product-card",
    "data-testid": "product-card"
  }, productCardDirection === 'column' && {
    maxW: {
      base: hitsDirection === 'column' ? "100%" : '50%',
      md: "50%",
      lg: "215px",
      xl: "268px"
    }
  }, productCardDirection === 'row' && {
    w: '100%'
  }, productCardDirection === 'column' && {
    w: {
      base: hitsDirection === 'column' ? "100%" : '50%',
      md: "50%",
      lg: "215px",
      xl: "268px"
    },
    flexBasis: {
      base: hitsDirection === 'column' ? "100%" : '50%',
      md: "50%",
      lg: "215px",
      xl: "268px"
    }
  }, {
    mb: productCardDirection === 'row' ? '30px' : 0,
    flex: "1",
    ml: {
      base: hitsDirection === 'column' ? 0 : index % 2 === 0 ? '-0.5rem' : '0.5rem',
      md: index % 2 === 0 ? '-0.5rem' : '0.5rem',
      lg: hitsDirection === 'row' ? isFirst ? '-0.5rem' : '0.5rem' : 0
    },
    mr: {
      base: hitsDirection === 'column' ? 0 : index % 2 === 0 ? '0.5rem' : '-0.5rem',
      md: index % 2 === 0 ? '0.5rem' : '-0.5rem',
      lg: hitsDirection === 'row' ? isLast ? '-0.5rem' : '0.5rem' : 0
    }
  }, restProps), /*#__PURE__*/_react["default"].createElement(_core.Link, _extends({
    d: "flex",
    flexDirection: productCardDirection,
    href: "/products/".concat(product.slug),
    color: fontColour,
    _hover: {
      color: fontColour
    },
    onClick: function onClick(e) {
      e.preventDefault();

      if (isEditMode) {
        return null;
      } else {
        window.location = "/products/".concat(product.slug);
      }
    }
  }, productCardDirection === 'column' && {
    height: '100%'
  }), /*#__PURE__*/_react["default"].createElement(_core.Image, _extends({}, (0, _isObjectLike["default"])(product.attributes) && {
    alt: product.attributes.product_name
  }, {
    src: (firstImage === null || firstImage === void 0 ? void 0 : firstImage.location) || fallbackImage || '',
    w: "100%",
    flex: "1",
    maxW: productCardDirection === 'row' ? '50%' : 'none',
    className: "product-card__media",
    "data-testid": "product-card__media"
  })), /*#__PURE__*/_react["default"].createElement(_core.Text, {
    fontWeight: "bold",
    fontSize: {
      base: "14px",
      lg: "16px"
    },
    lineHeight: "20px",
    mt: productCardDirection === 'column' ? "10px" : 0,
    ml: productCardDirection === 'row' ? "10px" : 0,
    fontFamily: fontFamily,
    className: "product-card__name",
    "data-testid": "product-card__name",
    flex: "1"
  }, (0, _isObjectLike["default"])(product.attributes) && product.attributes.product_name)));
};

var Hits = function Hits(props) {
  var _window, _window$location;

  var hits = props.hits,
      isEditMode = props.isEditMode,
      productCardDirection = props.productCardDirection,
      hitsDirection = props.hitsDirection,
      fontColour = props.fontColour,
      fontFamily = props.fontFamily,
      fallbackImage = props.fallbackImage;
  var inStorefront = !((_window = window) !== null && _window !== void 0 && (_window$location = _window.location) !== null && _window$location !== void 0 && _window$location.pathname.includes('/content/edit/'));
  return hits.length > 0 ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, hits.map(function (hit, index) {
    return /*#__PURE__*/_react["default"].createElement(ProductCard, {
      key: (hit === null || hit === void 0 ? void 0 : hit.slug) || "hit_".concat(index),
      product: hit,
      isEditMode: isEditMode,
      productCardDirection: productCardDirection,
      hitsDirection: hitsDirection,
      fontColour: fontColour,
      fontFamily: fontFamily,
      fallbackImage: fallbackImage,
      index: index,
      isFirst: index === 0,
      isLast: index === hits.length - 1
    });
  })) : isEditMode || !inStorefront ? /*#__PURE__*/_react["default"].createElement(Icon, null) : null;
};

var CustomHits = (0, _reactInstantsearchDom.connectHits)(Hits);

var ProductsContent = function ProductsContent(_ref2) {
  var _ref2$numberOfProduct = _ref2.numberOfProducts,
      numberOfProducts = _ref2$numberOfProduct === void 0 ? 4 : _ref2$numberOfProduct,
      _ref2$attributes = _ref2.attributes,
      attributes = _ref2$attributes === void 0 ? [] : _ref2$attributes,
      _ref2$attributeOperat = _ref2.attributeOperator,
      attributeOperator = _ref2$attributeOperat === void 0 ? 'and' : _ref2$attributeOperat,
      _ref2$hitsAlignment = _ref2.hitsAlignment,
      hitsAlignment = _ref2$hitsAlignment === void 0 ? 'flex-start' : _ref2$hitsAlignment,
      _ref2$hitsDirection = _ref2.hitsDirection,
      hitsDirection = _ref2$hitsDirection === void 0 ? 'row' : _ref2$hitsDirection,
      _ref2$productCardDire = _ref2.productCardDirection,
      productCardDirection = _ref2$productCardDire === void 0 ? 'column' : _ref2$productCardDire,
      _ref2$fontColour = _ref2.fontColour,
      fontColour = _ref2$fontColour === void 0 ? '#000' : _ref2$fontColour,
      _ref2$fontFamily = _ref2.fontFamily,
      fontFamily = _ref2$fontFamily === void 0 ? 'body' : _ref2$fontFamily,
      _ref2$fallbackImage = _ref2.fallbackImage,
      fallbackImage = _ref2$fallbackImage === void 0 ? '' : _ref2$fallbackImage,
      isEditMode = _ref2.isEditMode;
  var config = (0, _peractoConfig.useConfig)();
  var algolia = config.get('algolia') || {};
  var applicationId = algolia.applicationId,
      searchApiKey = algolia.searchApiKey,
      indexName = algolia.indexName;
  var searchClient = (0, _lite["default"])(applicationId, searchApiKey);

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      facetFilters = _useState2[0],
      setFacetFilters = _useState2[1];

  (0, _react.useEffect)(function () {
    if ((attributes === null || attributes === void 0 ? void 0 : attributes.length) > 0) {
      var categories = attributes === null || attributes === void 0 ? void 0 : attributes.reduce(function (acc, _ref3) {
        var attribute = _ref3.attribute,
            value = _ref3.value;
        var attributeKey = UNPREFIXED_ATTRIBUTES.includes(attribute) ? attribute : "attributes.".concat(attribute);
        if (value.length > 0) acc.push("".concat(attributeKey, ":").concat(value));
        return acc;
      }, []);
      setFacetFilters(categories);
    }
  }, [attributes]);

  if ((0, _isEmpty["default"])(algolia)) {
    console.error('No Algolia configuration defined. Please refer to the Peracto documentation.');
    return null;
  }

  return (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react["default"].createElement(_reactInstantsearchDom.InstantSearch, {
      searchClient: searchClient,
      indexName: indexName
    }, /*#__PURE__*/_react["default"].createElement(_reactInstantsearchDom.Configure, {
      hitsPerPage: numberOfProducts,
      facetFilters: facetFilters ? attributeOperator === 'and' ? facetFilters : [facetFilters] : null
    }), /*#__PURE__*/_react["default"].createElement(CustomHits, {
      isEditMode: isEditMode,
      productCardDirection: productCardDirection,
      hitsDirection: hitsDirection,
      fontColour: fontColour,
      fontFamily: fontFamily,
      fallbackImage: fallbackImage
    }));
  }, [facetFilters, numberOfProducts, attributeOperator, productCardDirection, fontColour, fontFamily, isEditMode, hitsAlignment, hitsDirection, fallbackImage]);
};

var ProductsRenderer = function ProductsRenderer(_ref4) {
  var state = _ref4.state,
      props = _objectWithoutProperties(_ref4, _excluded2);

  var _state$hitsDirection = state.hitsDirection,
      hitsDirection = _state$hitsDirection === void 0 ? 'row' : _state$hitsDirection,
      hitsAlignment = state.hitsAlignment;
  return /*#__PURE__*/_react["default"].createElement(_core.Stack, {
    className: "product-card-container content__products",
    flexDirection: hitsDirection,
    flexWrap: {
      base: 'wrap',
      lg: 'nowrap'
    },
    justifyContent: hitsDirection === 'row' ? hitsAlignment : null,
    alignItems: hitsDirection === 'column' ? hitsAlignment : null,
    p: hitsDirection === 'row' ? '0.5rem' : 0
  }, /*#__PURE__*/_react["default"].createElement(ProductsContent, _extends({}, state, props)));
};

var _default = ProductsRenderer;
exports["default"] = _default;